"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  send: function send(data) {
    return global.request.post('package-requests/send', data);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsImdsb2JhbCIsInJlcXVlc3QiLCJwb3N0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvUGFja2FnZVJlcXVlc3QvUGFja2FnZVJlcXVlc3RBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuICAgIHNlbmQ6IChkYXRhKSA9PiBnbG9iYWwucmVxdWVzdC5wb3N0KCdwYWNrYWdlLXJlcXVlc3RzL3NlbmQnLCBkYXRhKSxcclxufVxyXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztvQ0FBZTtFQUNYQSxJQUFJLEVBQUUsU0FBTkEsSUFBSUEsQ0FBR0MsSUFBSTtJQUFBLE9BQUtDLE1BQU0sQ0FBQ0MsT0FBTyxDQUFDQyxJQUFJLENBQUMsdUJBQXVCLEVBQUVILElBQUksQ0FBQztFQUFBO0FBQ3RFLENBQUMifQ==